import styled from "styled-components";

const FormGroup = styled.div`
    margin-bottom: ${ ( { theme } ) => theme.form.margin }rem;
`;

export default FormGroup;
